import { useTwistTheme } from '../config/store';
import { css } from '@emotion/css';
import { isFunction } from 'lodash-es';
import { get } from 'svelte/store';
import { toFluidPixelValue, toPixelValue } from './cssVarsConvert';
export class ResponsiveVars {
    variables;
    breakpoints;
    constructor() {
        const themeStore = useTwistTheme();
        const theme = get(themeStore);
        this.variables = {};
        this.breakpoints = Object.assign({ min: 0 }, theme.screens);
    }
    addResponsive(name, prop, fn) {
        const values = this.toValuesArray(prop);
        this.variables[name] = {};
        Object.keys(this.breakpoints).forEach((breakpointName, i) => {
            const currentIndex = i > values.length - 1 ? values.length - 1 : i;
            let value = values[currentIndex];
            if (isFunction(fn)) {
                value = fn(value, breakpointName);
            }
            this.variables[name][breakpointName] = value;
        });
        return this;
    }
    addFluid(name, values) {
        const breakpointNames = Object.keys(this.breakpoints);
        const findValue = (breakpoint) => {
            return values.find((value) => {
                if (value[0] === breakpoint) {
                    return true;
                }
                if (value.length === 2) {
                    return false;
                }
                const breakpointI = breakpointNames.indexOf(breakpoint);
                const fromI = breakpointNames.indexOf(value[0]);
                const toI = breakpointNames.indexOf(value[1]);
                return breakpointI > fromI && breakpointI < toI;
            });
        };
        this.variables[name] = {};
        for (const breakpoint of breakpointNames) {
            const breakpointValue = findValue(breakpoint);
            if (!breakpointValue) {
                continue;
            }
            if (breakpointValue.length === 2) {
                this.variables[name][breakpoint] = toPixelValue(breakpointValue[1]);
            }
            else {
                const [minBreakpoint, maxBreakpoint, minValue, maxValue] = breakpointValue;
                this.variables[name][breakpoint] = toFluidPixelValue({
                    minValue,
                    maxValue,
                    minBreakpoint: this.breakpoints[minBreakpoint],
                    maxBreakpoint: this.breakpoints[maxBreakpoint]
                });
            }
        }
        return this;
    }
    toCSS() {
        const lines = [];
        for (const [breakpointName, breakpoint] of Object.entries(this.breakpoints)) {
            lines.push(`@media screen and (min-width: ${breakpoint}px) {`);
            for (const [varName, varValue] of Object.entries(this.variables)) {
                if (varValue[breakpointName]) {
                    lines.push(`--${varName}: ${varValue[breakpointName]};`);
                }
            }
            lines.push('}');
        }
        return css(lines.join('\n'));
    }
    toValuesArray(value) {
        if (!value) {
            return [];
        }
        if (Array.isArray(value)) {
            return value;
        }
        if (typeof value !== 'object') {
            return [value];
        }
        const valueObject = value;
        const objectPropKeys = Object.keys(this.breakpoints);
        return objectPropKeys.reduce((values, key, i) => {
            let value = valueObject[key];
            if (!value) {
                value = values[i - 1];
            }
            values.push(value);
            return values;
        }, []);
    }
}
